import {toRef} from "vue";
import {useUserinfo} from "@/stores/userinfo";
import baseUrl from "./base"
import {postRequest, postRequestCustomHeaders, getRequest, getRequestCustomHeaders} from "./common"

const config = {
    headers: {
        // "Accept": "*/*",
        // "Access-Control-Allow-Origin": "*",
        "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8",
    }
}

//響應機制的userinfo
const userInfoRef = toRef(useUserinfo())

const userApi = {
    //查詢商家信息
    "queryBusinessBase": {
        send: (data, callback, failCallback, errorCallback) => {
            postRequest(`${baseUrl.shopopeeHttp}user/queryBusinessBase`, data, callback, failCallback, errorCallback)
        },
        getParams: () => {
            return {
                companycode: null
            }
        }
    },
    //查詢用戶基本信息
    "querySimpleMember": {
        send: (data, callback, failCallback, errorCallback) => {
            postRequest(`${baseUrl.shopopeeHttp}user/querySimpleMember`, data, callback, failCallback, errorCallback)
        },
        getParams: () => {
            return {
                login: null,
                shopid: "adminTag"
            }
        }
    },
    //查詢郵箱是否重複
    "checkRegEmail": {
        send: (data, callback, failCallback, errorCallback) => {
            postRequestCustomHeaders(`${baseUrl.shopopeeHttp}user/checkRegEmail`,  data, config, callback, failCallback, errorCallback)
        },
        getParams: () => {
            return {
                email: null
            }
        }
    },
    //設置3D店員
    "update3dShop": {
        send: (data, callback, failCallback, errorCallback) => {
            postRequest(`${baseUrl.shopopeeHttp}user/update3dShop`,  data, callback, failCallback, errorCallback)
        },
        getParams: () => {
            return {
                companycode: null,
                id: null
            }
        }
    },
    //修改用戶eshopopee域名
    "updateAddinfo7": {
        send: (data, callback, failCallback, errorCallback) => {
            postRequest(`${baseUrl.shopopeeHttp}user/updateAddinfo7`,  data, callback, failCallback, errorCallback)
        },
        getParams: () => {
            return {
                login: null,
                companycode: null,
                addinfo7: null
            }
        }
    },
    //获取系统设置
    "getTool1Setting": {
        send: (data, callback, failCallback, errorCallback) => {
            postRequest(`${baseUrl.shopopeeHttp}user/getTool1Setting`,  data, callback, failCallback, errorCallback)
        },
        getParams: () => {
            return {}
        }
    },
    //用户登录
    "login": {
        send: (data, callback, failCallback, errorCallback) => {
            postRequest(`${baseUrl.shopopeeHttp}user/login`,  data, callback, failCallback, errorCallback)
        },
        getParams: () => {
            return {
                login: null,
                password: null
            }
        }
    },
    //發送驗證碼
    "sendVCode": {
        send: (data, callback, failCallback, errorCallback) => {
            postRequest(`${baseUrl.shopopeeHttp}user/sendVCode`,  data, callback, failCallback, errorCallback)
        },
        getParams: () => {
            return {
                login: null,
                membergroup: null  //邀请码
            }
        }
    },
    //查詢驗證碼是否有效
    "checkEmailAndVCode": {
        send: (data, callback, failCallback, errorCallback) => {
            postRequest(`${baseUrl.shopopeeHttp}user/checkEmailAndVCode`,  data, callback, failCallback, errorCallback)
        },
        getParams: () => {
            return {
                login: null,
                vcode: null
            }
        }
    },
    //註冊
    "signupForCompany": {
        send: (data, callback, failCallback, errorCallback) => {
            postRequest(`${baseUrl.shopopeeHttp}user/signupForCompany`,  data, callback, failCallback, errorCallback)
        },
        getParams: () => {
            return {
                login: null,
                addinfo3: null,
                telephone: null,
                password: null,
                name: null,
                memmale: null,
                blockasp: -1,
                country: null,
                membergroup: null,
                verify: null,
                companycode: null,  //父公司companycode
            }
        }
    },
    //初始化用户信息
    "updateDefaultPass": {
        send: (data, callback, failCallback, errorCallback) => {
            postRequest(`${baseUrl.shopopeeHttp}user/updateDefaultPass`,  data, callback, failCallback, errorCallback)
        },
        getParams: () => {
            return {
                id: null,  //用户id
                password: null,
                name: null,
                telephone: null,
                memmale: null,
                companycode: null,
                addinfo2: null,  //聊天id
                mpfaccount: null  //电话区号
            }
        }
    },
    //查詢用戶列表
    "getMemberByPageForAdmin": {
        send: (data, callback, failCallback, errorCallback) => {
            postRequest(`${baseUrl.shopopeeHttp}user/getMemberByPageForAdmin`,  data, callback, failCallback, errorCallback)
        },
        getParams: () => {
            return {
                membergroup: null, //父公司id
                name: null,
                pageNum: 1,
                pageSize: 10
            }
        }
    },
    //註銷用戶
    "logoffMember": {
        send: (data, callback, failCallback, errorCallback) => {
            postRequest(`${baseUrl.shopopeeHttp}user/logoffMember`,  data, callback, failCallback, errorCallback)
        },
        getParams: () => {
            return {
                id: null, //用戶id
            }
        }
    },
}

export default userApi